(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baxxd-crue"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.crueReady) return;
    root.dataset.crueReady = 'true';
    const slides = [...root.querySelectorAll('.crue-scene')];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    const timer = window.setInterval(() => {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      if (motion.matches || document.hidden || root.querySelector('form:focus-within')) return;
      const next = (index + 1) % slides.length;
      const image = slides[next].querySelector('img');
      if (!image || !image.complete || !image.naturalWidth) return;
      slides[next].classList.add('is-active');
      slides[index].classList.remove('is-active');
      index = next;
    }, 3000);
    const success = root.querySelector('[data-crue-success]');
    if (success) success.focus({preventScroll:true});
  }
  document.querySelectorAll('.crue').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.crue').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
